import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { ClipBoardService } from '../../../services/clipboard.service'
import { ServerService } from '../../../services/server.service'
import { IMyDateRangeModel } from 'mydaterangepicker';

@Component({
    selector: 'app-campaign-filter-modal',
    templateUrl: './campaign-filter-modal.component.html',
    styleUrls: ['./campaign-filter-modal.component.scss'],
    encapsulation:ViewEncapsulation.None
})
export class CampaignFilterModalComponent implements OnInit {

    public authToken = localStorage.getItem("token");
    public projectInfo = JSON.parse(localStorage.getItem('projectInfo'));
    userInfo: any = JSON.parse(localStorage.getItem("userInfo"))

    createdByList: any;
    accountManagerList:any;
    salePersonList: any;
    saleCityList:any;
    mmList: any;
    assignUserList: any;

    showComponentLoader: boolean = true;

    campaign_status: any = ''

    finance_approved: any = '';
    campaign_type: string = "";
    client_type: string = "";
    created_by: string = null;
    account_manager: string = null;
    marketing_manager: string = null;
    assigned_user: string = null;
    sale_person: string = null;
    createdAt: any = ""
    saleCity: string = null;
    assignedToMe: boolean = false
 

    myDateRangePickerOptions = {
        dateFormat: 'dd.mm.yyyy'
    };

    commonDetail:any;

    task_status = [
        { id: 1, name: 'To Do' },
        { id: 2, name: 'In Progress' },
        { id: 3, name: 'Waiting Input' },
        { id: 4, name: 'Done' },
      ];
      selectedTaskStatuses: any[] = [1,2,3];// Holds selected IDs
      creative_status = [
        { id: 1, name: 'To Do' },
        { id: 2, name: 'In Progress' },
        { id: 3, name: 'Shared For Approval' },
        { id: 4, name: 'Awaiting Update' },
        { id: 5, name: 'On Hold' },
        { id: 6, name: 'Done' },
        { id: 7, name: 'Cancelled' },
        
      ];
      selectedCreativeStatuses: any[] = [1,2,3,4,5];

      marketing_status = [
        { id: 1, name: 'To Do' },
        { id: 2, name: 'In Progress' },
        { id: 3, name: 'Shared For Approval' },
        { id: 4, name: 'Awaiting Update' },
        { id: 5, name: 'On Hold' },
        { id: 6, name: 'Done' },
        {
            id:7,name:'Live'
        },
        {
            id:8,name:'Cancelled'
        }
      ];
      selectedMarketingStatuses: any[] = [1,2,3,4,5];

      presales_status = [
        { id: 1, name: 'To Do' },
        { id: 2, name: 'In Progress' },
        { id: 3, name: 'On Hold' },
        { id: 4, name: 'Awaiting Update' },
       
        { id: 5, name: 'Done' },
        
        {
            id:6,name:'Cancelled'
        }
      ];
      selectedPresalesStatuses: any[] = [1,2,3,4];

      escalation_status = [
        { id: 1, name: 'Open' },  
        { id: 2, name: 'Pending' },
        { id: 3, name: 'In Progress' },
        { id: 4, name: 'Resolved' },
        { id: 5, name: 'Closed' },
        
        {
            id:6,name:'Cancelled'
        }
      ];
      selectedEscalationStatuses: any[] = [1,2,3];

    isAllSelected = false;
    isAllSelectedCreative = false;
    isAllSelectedMarketing = false;
    isAllSelectedPresales = false;

    marketing_job_checkbox = false;
    presales_job_checkbox = false;
    escalation_checkbox = false;
    campaign_task_checkbox:any = false
    creative_job_checkbox:any = false
    escalation_job_checkbox:any = false


    allowModuleStatusFilter = false;

      search_filter = []
       moduleMap = {
        creative_jobs: {
          checkbox: 'creative_job_checkbox',
          statuses: 'selectedCreativeStatuses',
          statusList: 'creative_status',
        },
        campaign_tasks: {
          checkbox: 'campaign_task_checkbox',
          statuses: 'selectedTaskStatuses',
          statusList: 'task_status',
        },
        marketing_jobs: {
          checkbox: 'marketing_job_checkbox',
          statuses: 'selectedMarketingStatuses',
          statusList: 'marketing_status',
        },
        pre_sales_jobs: {
          checkbox: 'presales_job_checkbox',
          statuses: 'selectedPresalesStatuses',
          statusList: 'presales_status',
        },
        escalations: {
          checkbox: 'escalation_checkbox',
          statuses: 'selectedEscalationStatuses',
          statusList: 'escalation_status',
        },
      };
      
    

    constructor(
        private serverService: ServerService,
        private clipBoardService: ClipBoardService,
        private dialogRef: MatDialogRef<CampaignFilterModalComponent>,
        @Inject(MAT_DIALOG_DATA) private data
    ) {       

        if (data.campaign_status != undefined) {
            this.campaign_status = data.campaign_status;
        }

        if (data.finance_approved != undefined) {
            this.finance_approved = data.finance_approved;
        }

        if (data.campaign_type != undefined) {
            this.campaign_type = data.campaign_type;
        }

        if (data.client_type != undefined) {
            this.client_type = data.client_type;
        }

        if (data.created_by!= undefined && data.created_by!= null) {
            this.created_by = data.created_by;
        } 

        if (data.marketing_manager_id!= undefined && data.marketing_manager_id!= null) {
            this.marketing_manager = data.marketing_manager_id;
        }      
        
        if (data.account_manager_id!= undefined && data.account_manager_id!= null) {
            this.account_manager = data.account_manager_id;
        } 

        if (data.sales_manager_id != undefined && data.sales_manager_id != null) {
            this.sale_person = data.sales_manager_id;
        }  
        
        if (data.assigned_user_id != undefined && data.assigned_user_id != null) {
            this.assigned_user = data.assigned_user_id;
        } 

        if (data.createdAt != undefined) {
            this.createdAt = data.createdAt
        }

        if (data.sales_city!= undefined && data.sales_city!= null) {
            this.saleCity = data.sales_city;
        }

        if ( data.assigned_to_me) {
            this.assignedToMe = data.assigned_to_me
        }       
        // console.log(data) 
        // data.module_status_filters.forEach(element => {

        //   console.log(element)
        //   if(element.module_name == 'creative_jobs'){
        //     this.creative_job_checkbox = true;
        //     this.selectedCreativeStatuses = this.creative_status
        //     .filter((data) => element.statuses.includes(data.name)) // Check if the name exists in element.statuses
        //     .map((data) => data.id); 
        //     // this.selectedCreativeStatuses = this.creative_status.map((data)=>data.name == element.statuses)
        //   }
        //   if(element.module_name == 'campaign_tasks'){
        //     this.campaign_task_checkbox = true;
        //     this.selectedTaskStatuses = this.task_status
        //     .filter((data) => element.statuses.includes(data.name)) // Check if the name exists in element.statuses
        //     .map((data) => data.id); 
        //     // this.selectedCreativeStatuses = this.creative_status.map((data)=>data.name == element.statuses)
        //   }
        //   if(element.module_name == 'marketing_jobs'){
        //     this.marketing_job_checkbox = true;
        //     this.selectedMarketingStatuses = this.marketing_status
        //     .filter((data) => element.statuses.includes(data.name)) // Check if the name exists in element.statuses
        //     .map((data) => data.id); 
        //     // this.selectedCreativeStatuses = this.creative_status.map((data)=>data.name == element.statuses)
        //   }
        //   if(element.module_name == 'pre_sales_jobs'){
        //     this.presales_job_checkbox = true;
        //     this.selectedPresalesStatuses = this.presales_status
        //     .filter((data) => element.statuses.includes(data.name)) // Check if the name exists in element.statuses
        //     .map((data) => data.id); 
        //     // this.selectedCreativeStatuses = this.creative_status.map((data)=>data.name == element.statuses)
        //   }
        //   if(element.module_name == 'escalations'){
        //     this.escalation_checkbox = true;
        //     this.selectedEscalationStatuses = this.escalation_status
        //     .filter((data) => element.statuses.includes(data.name)) // Check if the name exists in element.statuses
        //     .map((data) => data.id); 
        //     // this.selectedCreativeStatuses = this.creative_status.map((data)=>data.name == element.statuses)
        //   }
          
        // });
        if(data.module_status_filters){
        data.module_status_filters.forEach((element) => {
          const module = this.moduleMap[element.module_name];
          if (module) {
            this[module.checkbox] = true;
            this[module.statuses] = this[module.statusList]
              .filter((data) => element.statuses.includes(data.name))
              .map((data) => data.id);
          }
        });
      }

    }

    ngOnInit() {
        this.getAllUser()
        this.getSP()
        this.getMM()
        this.getDropDown()


    }

    filterLead() {

        let body = {}
        this.moduleStatusFilters();
        if (this.campaign_status != undefined && this.campaign_status != "") {
            body["campaign_status"] = this.campaign_status;
        }

        if (this.finance_approved != undefined && this.finance_approved != '') {
            body["finance_approved"] = this.finance_approved
          }

        if (this.campaign_type != undefined && this.campaign_type != "") {
            body["campaign_type"] = this.campaign_type;
        }

        if (this.client_type != undefined && this.client_type != "") {
            body["client_type"] = this.client_type;
        }

        if ( (this.created_by != undefined || this.created_by != null) && this.created_by != "") {
            body["created_by"] = this.created_by;
        }

        if ( (this.marketing_manager != undefined || this.marketing_manager != null) && this.marketing_manager != "") {
            body["marketing_manager_id"] = this.marketing_manager;
        }

        if ( (this.account_manager != undefined || this.account_manager != null) && this.account_manager != "") {
            body["account_manager_id"] = this.account_manager;
        }

        if ( (this.sale_person != undefined || this.sale_person != null) && this.sale_person != "") {
            body["sales_manager_id"] = this.sale_person;
        }

        if ( (this.assigned_user != undefined || this.assigned_user != null) && this.assigned_user != "") {
            body["assigned_user_id"] = this.assigned_user;
        }

        if (this.createdAt != undefined && this.createdAt != "") {
            body["createdAt"] = this.createdAt
        }

        if ( (this.saleCity != undefined || this.saleCity != null) && this.saleCity != "") {
            body["sales_city"] = this.saleCity;
        }

        if ( this.assignedToMe) {
            body["assigned_to_me"] = this.assignedToMe
        }        
        // console.log("hi",this.search_filter)
        if(this.search_filter){
            body['module_status_filters'] = this.search_filter
        }
        // console.log("hi",this.search_filter)
        // console.log(body)
        this.dialogRef.close(body)
    }

    close() {
        this.dialogRef.close();
    }

    clear() {
        this.campaign_status = "";
        this.finance_approved = false;
        this.campaign_type = "";
        this.client_type = "";
        this.created_by = null;        
        this.marketing_manager = null;
        this.account_manager = null;
        this.assigned_user = null;
        this.sale_person = null;
        this.createdAt = null;
        this.saleCity = null;
        this.assignedToMe = false;
        this.marketing_job_checkbox = false;
        this.presales_job_checkbox = false;
        this.escalation_checkbox = false;
        this.campaign_task_checkbox = false
        this.creative_job_checkbox = false
        this.escalation_job_checkbox = false

    }

    getAllUser(){
        this.showComponentLoader = true
        this.serverService.getActiveUsers(this.authToken).subscribe(data => {
            this.createdByList = data.data
            this.accountManagerList = data.data.filter(person => person.org_admin === true);
            this.assignUserList = data.data;
            this.showComponentLoader = false
        },
            err => {
                this.showComponentLoader = false
                this.clipBoardService.checkServerError(err, this.authToken)
            }
        )
    }

    getSP() {

        this.showComponentLoader = true

        let url = "/campaign_module/user_list?user_type=SalesAdmin";
        this.serverService.getSalePerson(url, this.authToken).subscribe(data => {
            this.salePersonList = data.data
            //console.log(this.salePersonList)
            this.showComponentLoader = false
        },
            err => {
                this.showComponentLoader = false
                this.clipBoardService.checkServerError(err, this.authToken)
            }
        )

    }

    getMM() {

        this.showComponentLoader = true
        //let url = "/campaign_module/get_marketing_user";
        let url = "/campaign_module/campaigns/get_assigned_marketing_manager";
        this.serverService.getSalePerson(url, this.authToken).subscribe(data => {
            this.mmList = data.data
            //console.log(this.mmList)
            this.showComponentLoader = false
        },
            err => {
                this.showComponentLoader = false
                this.clipBoardService.checkServerError(err, this.authToken)
            }
        )

    }

    getDropDown() {

        this.showComponentLoader = true;
    
        let url = "campaign_module/get_common_details";
    
        this.serverService.getLeadDeliveryDropDown(url, this.authToken).subscribe(data => {
          //console.log(data)
          this.saleCityList = data.campaign_sales_city_list
          //console.log(this.saleCityList)
          this.showComponentLoader = false
        },
          err => {
            this.showComponentLoader = false
            this.clipBoardService.checkServerError(err, this.authToken)
          }
        )
    }

    userType(item) {
        return item.org_admin && !item.role
          ? 'Vendor Admin'
          : !item.org_admin && !item.role
          ? 'Vendor Standard User'
          : item.role;
    }
    checkboxfilter(event:any){
        // console.log(event)
        // console.log(this.campaign_task_checkbox)
    }
    getSelectedLabel(): any {
        // console.log(this.selectedTaskStatuses)
        if (this.selectedTaskStatuses.length === 0) {
          return 'Select Task Status';
        }
        return `${this.selectedTaskStatuses.length} selected`;
      }
    
      // Toggles "Select All"
      toggleSelectAll(event: any): void {
      
        this.isAllSelected = event.target.checked;
    
        if (this.isAllSelected) {
          this.selectedTaskStatuses = this.task_status.map((status) => status.id); // Select all IDs
        } else {
          this.selectedTaskStatuses = []; // Clear all selections
        }
      }
    
      // Toggles individual selection
      toggleSelection(id: any, event: any,item:any): void {
       
        
        if (event.target.checked) {
            
          // Add the ID to the selectedTaskStatuses array if not already present
          if (!this.selectedTaskStatuses.includes(id)) {
          
            this.selectedTaskStatuses.push(id);
          }
        } else {
          // Remove the ID from the selectedTaskStatuses array
          this.selectedTaskStatuses = this.selectedTaskStatuses.filter(
            (statusId) => statusId != id
          );
        }
    
    
        // Update "Select All" state
        this.isAllSelected =
          this.selectedTaskStatuses.length === this.task_status.length;
      }
      //Creative job

      getSelectedLabelCreative(): any {
        
        if (this.selectedCreativeStatuses.length === 0) {
          return 'Select Task Status';
        }
        return `${this.selectedCreativeStatuses.length} selected`;
      }
    
      // Toggles "Select All"
      toggleSelectAllCreative(event: any): void {
      
        this.isAllSelected = event.target.checked;
    
        if (this.isAllSelected) {
          this.selectedCreativeStatuses = this.creative_status.map((status) => status.id); // Select all IDs
        } else {
          this.selectedCreativeStatuses = []; // Clear all selections
        }
      }
    
      // Toggles individual selection
      toggleSelectionCreative(id: any, event: any,item:any): void {
      
        
        if (event.target.checked) {
          
          // Add the ID to the selectedCreativeStatuses array if not already present
          if (!this.selectedCreativeStatuses.includes(id)) {
            
            this.selectedCreativeStatuses.push(id);
          }
        } else {
          // Remove the ID from the selectedCreativeStatuses array
          this.selectedCreativeStatuses = this.selectedCreativeStatuses.filter(
            (statusId) => statusId != id
          );
        }
       
    
        // Update "Select All" state
        this.isAllSelected =
          this.selectedCreativeStatuses.length === this.task_status.length;
      }
//end creative 

   //marketing job

   getSelectedLabelMarketing(): any {
        
    if (this.selectedMarketingStatuses.length === 0) {
      return 'Select Task Status';
    }
    return `${this.selectedMarketingStatuses.length} selected`;
  }

  // Toggles "Select All"
  toggleSelectAllMarketing(event: any): void {
  
    this.isAllSelected = event.target.checked;

    if (this.isAllSelected) {
      this.selectedMarketingStatuses = this.marketing_status.map((status) => status.id); // Select all IDs
    } else {
      this.selectedMarketingStatuses = []; // Clear all selections
    }
  }

  // Toggles individual selection
  toggleSelectionMarketing(id: any, event: any,item:any): void {
  
    
    if (event.target.checked) {
      
      // Add the ID to the selectedMarketingStatuses array if not already present
      if (!this.selectedMarketingStatuses.includes(id)) {
        
        this.selectedMarketingStatuses.push(id);
      }
    } else {
      // Remove the ID from the selectedMarketingStatuses array
      this.selectedMarketingStatuses = this.selectedMarketingStatuses.filter(
        (statusId) => statusId != id
      );
    }
   

    // Update "Select All" state
    this.isAllSelected =
      this.selectedMarketingStatuses.length === this.task_status.length;
  }
//end marketing 
  //Presales job

  getSelectedLabelPresales(): any {
        
    if (this.selectedPresalesStatuses.length === 0) {
      return 'Select Task Status';
    }
    return `${this.selectedPresalesStatuses.length} selected`;
  }

  // Toggles "Select All"
  toggleSelectAllPresales(event: any): void {
  
    this.isAllSelected = event.target.checked;

    if (this.isAllSelected) {
      this.selectedPresalesStatuses = this.presales_status.map((status) => status.id); // Select all IDs
    } else {
      this.selectedPresalesStatuses = []; // Clear all selections
    }
  }

  // Toggles individual selection
  toggleSelectionPresales(id: any, event: any,item:any): void {
  
    
    if (event.target.checked) {
      
      // Add the ID to the selectedPresalesStatuses array if not already present
      if (!this.selectedPresalesStatuses.includes(id)) {
        
        this.selectedPresalesStatuses.push(id);
      }
    } else {
      // Remove the ID from the selectedPresalesStatuses array
      this.selectedPresalesStatuses = this.selectedPresalesStatuses.filter(
        (statusId) => statusId != id
      );
    }
   

    // Update "Select All" state
    this.isAllSelected =
      this.selectedPresalesStatuses.length === this.presales_status.length;
  }
//end marketing 

//escalation job

getSelectedLabelEscalation(): any {
        
    if (this.selectedEscalationStatuses.length === 0) {
      return 'Select Task Status';
    }
    return `${this.selectedEscalationStatuses.length} selected`;
  }

  // Toggles "Select All"
  toggleSelectAllEscalation(event: any): void {
  
    this.isAllSelected = event.target.checked;

    if (this.isAllSelected) {
      this.selectedEscalationStatuses = this.escalation_status.map((status) => status.id); // Select all IDs
    } else {
      this.selectedEscalationStatuses = []; // Clear all selections
    }
  }

  // Toggles individual selection
  toggleSelectionEscalation(item: any, event: any): void {
  
    // console.log(id)
    let id = item.id

    if (event.target.checked) {
      
      // Add the ID to the selectedEscalationStatuses array if not already present
      if (!this.selectedEscalationStatuses.includes(id)) {
        
        this.selectedEscalationStatuses.push(id);
      }
    } else {
      // Remove the ID from the selectedEscalationStatuses array
      this.selectedEscalationStatuses = this.selectedEscalationStatuses.filter(
        (statusId) => statusId != id
      );
    }
   

    // Update "Select All" state
    this.isAllSelected =
      this.selectedEscalationStatuses.length === this.escalation_status.length;
  }
//end escalation 
moduleStatusFilters(){
  // debugger;
    if(this.selectedTaskStatuses.length != 0 && this.campaign_task_checkbox){
        
        this.selectedTaskStatuses = this.task_status
            .filter(task => this.selectedTaskStatuses.includes(task.id)) 
            .map(task => task.name); 
            this.search_filter.push({
                "module_name": "campaign_tasks",
            "statuses": this.selectedTaskStatuses
            })
        this.allowModuleStatusFilter = true
    }
    if(this.selectedCreativeStatuses.length != 0 && this.creative_job_checkbox){
        
      this.selectedCreativeStatuses = this.creative_status
          .filter(task => this.selectedCreativeStatuses.includes(task.id)) 
          .map(task => task.name); 
          this.search_filter.push({
              "module_name": "creative_jobs",
          "statuses": this.selectedCreativeStatuses
          })
      this.allowModuleStatusFilter = true
  }

  if(this.selectedMarketingStatuses.length != 0 && this.marketing_job_checkbox){
        
    this.selectedMarketingStatuses = this.marketing_status
        .filter(task => this.selectedMarketingStatuses.includes(task.id)) 
        .map(task => task.name); 
        this.search_filter.push({
            "module_name": "marketing_jobs",
        "statuses": this.selectedMarketingStatuses
        })
    this.allowModuleStatusFilter = true
}

if(this.selectedPresalesStatuses.length != 0 && this.presales_job_checkbox){
        
  this.selectedPresalesStatuses = this.presales_status
      .filter(task => this.selectedPresalesStatuses.includes(task.id)) 
      .map(task => task.name); 
      this.search_filter.push({
          "module_name": "pre_sales_jobs",
      "statuses": this.selectedPresalesStatuses
      })
  this.allowModuleStatusFilter = true
}
if(this.selectedEscalationStatuses.length != 0 && this.escalation_job_checkbox){
        
  this.selectedEscalationStatuses = this.escalation_status
      .filter(task => this.selectedEscalationStatuses.includes(task.id)) 
      .map(task => task.name); 
      this.search_filter.push({
          "module_name": "escalations",
      "statuses": this.selectedEscalationStatuses
      })
  this.allowModuleStatusFilter = true
}
    else{
        this.allowModuleStatusFilter = false;
    }
}

}
